var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('surveys-table',{attrs:{"surveyName":"TOPAS","surveyCode":"TOPAS","permission":{
      createSurvey: _vm.permissions.CREATE_SURVEY_TOPAS,
      viewDetail: _vm.permissions.SEE_DETAIL_SURVEY_TOPAS,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }